import loadingGif from '../../assets/img/loading.gif';
import React, { useState, useEffect, Fragment, useRef } from "react";
import Modal from 'react-bootstrap/Modal';
import Container from 'react-bootstrap/Container';
import axios from 'axios';
import AuthService from '../../Auth/AuthService.js';
import { settings } from '../../Helpers/Settings.js';
import { ToastContainer, toast } from "react-toastify";
import { useDownloadExcel } from 'react-export-table-to-excel';
import "react-toastify/dist/ReactToastify.css";
import Swal from 'sweetalert2'
import PageTitle from "../../Components/PageTitle.js";
import { decodeToken, isExpired } from "react-jwt";

const Cari = () => {
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const [loading, setLoading] = useState(false);

    const [isTokenExpired, setIsTokenExpired] = useState(false);
    const [yetkiGor, setYetkiGor] = useState(null);
    const [yetkiEkle, setYetkiEkle] = useState(false);
    const [yetkiDegistir, setYetkiDegistir] = useState(false);
    const [yetkiSil, setYetkiSil] = useState(false);

    const [cariTuruIdKriter, setCariTuruIdKriter] = useState(0);
    const [prm, setPrm] = useState("");
    const [currentId, setCurrentId] = useState(0);
    const [cariTuruId, setCariTuruId] = useState(0);
    const [cari, setCari] = useState('');
    const [kisaltma, setKisaltma] = useState('');
    const [adres, setAdres] = useState('');
    const [vergiDairesi, setVergiDairesi] = useState('');
    const [vergiNo, setVergiNo] = useState('');
    const [ilgili, setIlgili] = useState('');
    const [telefon, setTelefon] = useState('');
    const [mail, setMail] = useState('');
    const [iban, setIban] = useState('');
    const [swift, setSwift] = useState('');
    const [eori, setEori] = useState('');
    const [teslimatAdresi, setTeslimatAdresi] = useState('');
    const [vade, setVade] = useState(0);

    const [data, setData] = useState([]);
    const [dataCariTuru, setDataCariTuru] = useState([]);

    const [pageNo, setPageNo] = useState(1);
    const [lastPage, setLastPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [rowCount, setRowCount] = useState(0);
    //const [sort, setSort] = useState("");

    const tokenYenile = async () => {
        if (isExpired(localStorage.getItem('ATGroupToken')) === true) {
            setIsTokenExpired(true);
            setShow(false);
            return false;
        } else {
            const mail = decodeToken(localStorage.getItem('ATGroupToken'))["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/emailaddress"];
            await AuthService.login(mail, localStorage.getItem('ATGroupToken'));
            return true;
        }
    }

    const tableRef = useRef(null);

    useEffect(() => {
        getAcilisData();
    }, []);

    useEffect(() => {
        if (yetkiGor === true) {
            getData();
        }
    }, [cariTuruIdKriter, prm, pageNo, pageSize/*, sort*/]);

    const handleCariTuruKriterChange = (e) => {
        if (tokenYenile() === false) {
            return;
        }

        setCariTuruIdKriter(e.target.value);
    }

    const handlePrmChange = (e) => {
        if (tokenYenile() === false) {
            return;
        }

        setPrm(e.target.value);
    }

    const getAcilisData = async() => {
        if (tokenYenile() === false) {
            return;
        }

        let tempYetkiGor = await AuthService.getYetkiKontrolByYetki("ERP - Cari - Gör");

        setYetkiGor(tempYetkiGor);

        if (tempYetkiGor) {
            setYetkiEkle(await AuthService.getYetkiKontrolByYetki("ERP - Cari - Ekle"));
            setYetkiDegistir(await AuthService.getYetkiKontrolByYetki("ERP - Cari - Değiştir"));
            setYetkiSil(await AuthService.getYetkiKontrolByYetki("ERP - Cari - Sil"));

            setDataCariTuru((await axios.get(settings.ApiUrl + "Lookup/GetLookupBasic/CariTuru", { headers: AuthService.getHeaders() })).data.value);

            await getData();
        }
    }

    const getData = async () => {
        try {
            setLoading(true);

            const kriter = JSON.stringify({
                "id": 0,
                "cariTuruId": cariTuruIdKriter,
                "prm": prm,
                "sort": "",
                "pageNo": pageNo,
                "pageSize": pageSize
            });

            const res = await axios.post(settings.ApiUrl + 'Cari/GetCariList/', kriter, { headers: AuthService.getHeaders() });

            if (res) {
                setRowCount(res.data.rowCount);
                setLastPage(Math.ceil(res.data.rowCount / pageSize));
                setData(res.data.value);
            }
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    }


    const handlePageSize = async (e) => {
        if (tokenYenile() === false) {
            return;
        }
        await setPageNo(1);
        await setPageSize(e);
    }

    const handlePageNo = async (e) => {
        if (tokenYenile() === false) {
            return;
        }
        await setPageNo(e);
    }

    const NavIlk = async () => {
        if (tokenYenile() === false) {
            return;
        }
        await setPageNo(1);
    }

    const NavGeri = async () => {
        if ((pageNo - 1) >= 1) {
            if (tokenYenile() === false) {
                return;
            }
            await setPageNo(pageNo - 1);
        }
    }

    const NavIleri = async () => {
        if ((Number(pageNo) + 1) <= lastPage) {
            if (tokenYenile() === false) {
                return;
            }
            await setPageNo(Number(pageNo) + 1);
        }
    }

    const NavSon = async () => {
        if (tokenYenile() === false) {
            return;
        }
        await setPageNo(lastPage);
    }

    const Ekle = async () => {
        if (tokenYenile() === false) {
            return;
        }

        setCurrentId(0);
        setCariTuruId(0);
        setCari("");
        setKisaltma("");
        setAdres("");
        setVergiDairesi("");
        setVergiNo("");
        setIlgili("");
        setTelefon("");
        setMail("");
        setIban("");
        setIban("");
        setSwift("");
        setEori("");
        setTeslimatAdresi("");
        setVade(0);

        handleShow();
    }

    const Degistir = async (id) => {
        if (tokenYenile() === false) {
            return;
        }

        try {
            setLoading(true);

            const kriter = JSON.stringify({
                "id": id,
                "cariTuruId": 0,
                "prm": "",
                "sort": "",
                "pageNo": 1,
                "pageSize": 1
            });

            const res = await axios.post(settings.ApiUrl + 'Cari/GetCariList/', kriter, { headers: AuthService.getHeaders() });

            console.log(res);

            if (res) {
                setCurrentId(id);
                setCariTuruId(res.data.value[0].cariTuruId);
                setCari(res.data.value[0].cari);
                setKisaltma(res.data.value[0].kisaltma);
                setAdres(res.data.value[0].adres);
                setVergiDairesi(res.data.value[0].vergiDairesi);
                setVergiNo(res.data.value[0].vergiNo);
                setIlgili(res.data.value[0].ilgili);
                setTelefon(res.data.value[0].telefon);
                setMail(res.data.value[0].mail);
                setIban(res.data.value[0].iban);
                setIban(res.data.value[0].iban);
                setSwift(res.data.value[0].swift);
                setEori(res.data.value[0].eori);
                setTeslimatAdresi(res.data.value[0].teslimatAdresi);
                setVade(res.data.value[0].vade);

                handleShow();
            }
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    }

    const Sil = async (id) => {
        if (tokenYenile() === false) {
            return;
        }

        Swal.fire({
            title: "Uyarı",
            text: "Kayıt silinecek, emin misiniz?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Sil",
            cancelButtonText: "Vazgeç"
        }).then(async (resultSwal) => {
            if (resultSwal.isConfirmed) {
                try {
                    const kriter = JSON.stringify({
                        "id": id,
                        "cariTuruId": 0,
                        "prm": "",
                        "sort": "",
                        "pageNo": 1,
                        "pageSize": 1
                    });
        
                    const resultGet = await axios.post(settings.ApiUrl + 'Cari/GetCariList/', kriter, { headers: AuthService.getHeaders() });
        
                    if (resultGet) {
                        const resultDelete = await axios.post(settings.ApiUrl + 'Cari/DeleteCari/', [resultGet.data.value[0]], { headers: AuthService.getHeaders() });
                        
                        if (resultDelete) {
                            if (resultDelete.data.success === true) {
                                getData();
                                toast.success("Silindi");
                            } else {
                                toast.error(resultDelete.data.message);
                            }
                        }
                    }
                } catch (error) {
                    toast.error(error);
                }
            }
        });
    }

    const Kaydet = async () => {
        if (tokenYenile() === false) {
            return;
        }

        if (cariTuruId === 0 || cari === "" || kisaltma === "") {
            Swal.fire({ title: "Hata", text: "Lütfen zorunlu alanları doldurunuz", icon: "error" });
        } else {
            try {
                const data = JSON.stringify({
                    "id": currentId,
                    "cariTuruId": cariTuruId,
                    "cari": cari,
                    "kisaltma": kisaltma,
                    "adres": adres,
                    "vergiDairesi": vergiDairesi,
                    "vergiNo": vergiNo,
                    "ilgili": ilgili,
                    "telefon": telefon,
                    "mail": mail,
                    "iban": iban,
                    "swift": swift,
                    "eori": eori,
                    "teslimatAdresi": teslimatAdresi,
                    "vade": vade
                });
    
                const result = await axios.post(settings.ApiUrl + 'Cari/InsertOrUpdateCari/', data, { headers: AuthService.getHeaders() });

                if (result) {
                    if (result.data.success) {
                        handleClose();
                        getData();
                        toast.success("Kaydedildi");
                    } else {
                        toast.error("Hata oluştu: " + result.data.message);
                    }
                }
            } catch (error) {
                toast.error("Hata oluştu:" + error);
            }
        }
    }

    const { onDownload } = useDownloadExcel({
        currentTableRef: tableRef.current,
        filename: 'KullaniciListesi',
        sheet: 'KullaniciListesi'
    })

    return (
        <Fragment>
            <Container>
                <ToastContainer position="bottom-right">
                </ToastContainer>
            </Container>
            <div className="row">
                <div className="col-md-8">
                    <PageTitle></PageTitle>
                </div>
                <div className="col-md-4 text-right">
                    <div className="input-group input-group-sm mb-3">
                        <select className="form-select form-select-sm" value={cariTuruIdKriter} onChange={(e) => handleCariTuruKriterChange(e)}>
                            <option value="0"></option>
                            {
                                dataCariTuru && dataCariTuru.length > 0 ?
                                dataCariTuru.map((item, index) => {
                                    return (
                                        <option key={index} value={item.id}>{item.ad}</option>
                                    )
                                })
                                :
                                null
                            }
                        </select>
                        <input type="text" className="form-control" aria-describedby="inputGroup-sizing-sm" placeholder="Arama..." value={prm} onChange={(e) => handlePrmChange(e)}></input>
                        <span className="input-group-text" id="inputGroup-sizing-sm"><i className="bi bi-search"></i></span>
                    </div>
                </div>
            </div>

            {
                isTokenExpired === true ?
                    <div className="alert alert-danger mb-1">
                        <button className="btn btn-link btn-sm" style={{color:"#58151c"}} onClick={() => AuthService.logout()}>Uzun süredir işlem yapmadığınız için oturumunuz sonlandırıldı. Lütfen tekrar giriş yapınız.</button>
                    </div>
                    :
                    yetkiGor !== null ?
                        yetkiGor === false ?
                            <div className="alert alert-danger">
                                Bu sayfaya erişim yetkiniz bulunmamaktadır
                            </div>
                            :
                            <div className="card info-card mb-2">
                                {
                                    loading ?
                                        <div className="progressBackground">
                                            <div className="progressPopup">
                                            <img alt="Bekleyiniz..." src={loadingGif} />
                                            </div>
                                        </div>
                                        :
                                        ''
                                }
                                <div className="table-responsive">
                                    <table ref={tableRef} className="table table-bordered table-hover table-sm mb-0">
                                        <thead>
                                            <tr>
                                                <th style={{textAlign:"center"}}>Unvanı</th>
                                                <th style={{textAlign:"center"}}>Kısaltma</th>
                                                <th style={{textAlign:"center"}}>Cari Türü</th>
                                                <th style={{textAlign:"center"}}>Adres</th>
                                                <th style={{textAlign:"center"}}>Vergi Dairesi</th>
                                                <th style={{textAlign:"center"}}>Vergi No</th>
                                                <th style={{textAlign:"center"}}>İlgili</th>
                                                <th style={{textAlign:"center"}}>Telefon</th>
                                                <th style={{textAlign:"center"}}>E-Posta</th>
                                                <th style={{textAlign:"center"}}>Iban</th>
                                                <th style={{textAlign:"center"}}>IBAN</th>
                                                <th style={{textAlign:"center"}}>Swift</th>
                                                <th style={{textAlign:"center"}}>EORI</th>
                                                <th style={{textAlign:"center"}}>Teslimat Adresi</th>
                                                <th style={{textAlign:"center"}}>Vade (gün)</th>
                                                <th style={{textAlign:"center"}}>
                                                    { yetkiEkle ? <button className="btn btn-sm btn-icon text-success" onClick={() => Ekle()}><i className="bi bi-plus-circle"></i></button> : '' }
                                                    <button className="btn btn-sm btn-icon text-success" onClick={onDownload}><i className="bi bi-file-earmark-excel"></i></button>
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                data && data.length > 0 ?
                                                    data.map((item, index) => {
                                                        return (
                                                            <tr key={index}>
                                                                <td align="center">{item.cari}</td>
                                                                <td align="center">{item.kisaltma}</td>
                                                                <td align="center"><span className={item.cariTuruBadge}>{item.cariTuru}</span></td>
                                                                <td align="center">{item.adres}</td>
                                                                <td align="center">{item.vergiDairesi}</td>
                                                                <td align="center">{item.vergiNo}</td>
                                                                <td align="center">{item.ilgili}</td>
                                                                <td align="center">{item.telefon}</td>
                                                                <td align="center">{item.mail}</td>
                                                                <td align="center">{item.iban}</td>
                                                                <td align="center">{item.iban}</td>
                                                                <td align="center">{item.swift}</td>
                                                                <td align="center">{item.eori}</td>
                                                                <td align="center">{item.teslimatAdresi}</td>
                                                                <td align="center">{item.vade}</td>
                                                                <td align="center">
                                                                    { yetkiDegistir ? <button className="btn btn-sm btn-icon text-info" onClick={() => Degistir(item.id)}><i className="bi bi-pencil"></i></button> : '' }
                                                                    { yetkiSil ? <button className="btn btn-sm btn-icon text-danger" onClick={() => Sil(item.id)}><i className="bi bi-trash3"></i></button> : '' }
                                                                </td>
                                                            </tr>
                                                        )
                                                    })
                                                    :
                                                    <tr>
                                                        <td align="center" colSpan="11" style={{height:"48px"}}>
                                                            Kayıt yok
                                                        </td>
                                                    </tr>
                                            }
                                        </tbody>
                                    </table>
                                </div>
                                <div className="row" style={{ placeItems: "center", padding: "8px" }}>
                                    <div className="col-md-4" style={{ display: "ruby" }}>
                                        <span className="badge bg-primary">{rowCount + " kayıt"}</span>
                                    </div>
                                    <div className="col-md-4" style={{ textAlign: "-webkit-center" }}>
                                        <div style={{ display: "flex", width: "224px" }}>
                                            <button className="btn btn-sm btn-icon text-info" onClick={async () => NavIlk()}><i className="bi bi-caret-left-fill"></i></button>
                                            <button className="btn btn-sm btn-icon text-info" onClick={async () => NavGeri()}><i className="bi bi-caret-left"></i></button>
                                            <div className="input-group">
                                                <input type="text" className="form-control form-control-xsm text-center" value={pageNo} onChange={(e) => handlePageNo(e.target.value)}></input>
                                                <div className="form-control form-control-xsm text-center" style={{ borderLeft: "none" }}>{" / " + lastPage}</div>
                                            </div>
                                            <button className="btn btn-sm btn-icon text-info" onClick={async () => NavIleri()}><i className="bi bi-caret-right"></i></button>
                                            <button className="btn btn-sm btn-icon text-info" onClick={async () => NavSon()}><i className="bi bi-caret-right-fill"></i></button>
                                        </div>
                                    </div>
                                    <div className="col-md-4" style={{ textAlign: "-webkit-right" }}>
                                        <select className="form-select form-select-xsm" style={{ width: "128px" }} value={pageSize} onChange={async (e) => handlePageSize(e.target.value)}>
                                            <option value="5">5 kayıt göster</option>
                                            <option value="10">10 kayıt göster</option>
                                            <option value="25">25 kayıt göster</option>
                                            <option value="50">50 kayıt göster</option>
                                            <option value="100">100 kayıt göster</option>
                                            <option value="250">250 kayıt göster</option>
                                            <option value="500">500 kayıt göster</option>
                                            <option value="1000">1000 kayıt göster</option>
                                            <option value="5000">5000 kayıt göster</option>
                                            <option value="10000">10000 kayıt göster</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        :
                        ""
            }

            <Modal show={show} onHide={handleClose} size='xl' centered>
                <Modal.Header closeButton>
                    <Modal.Title>Cari Kaydı</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="row">
                        <div className="col-md-6 mb-3">
                            <div className="input-group input-group-sm">
                                <label className="input-group-text" id="lblCari" style={{width:"128px"}}>Unvanı<span style={{color:"red", paddingLeft:"4px"}}>*</span></label>
                                <input aria-describedby="lblCari" type="text" className="form-control form-control-sm" value={cari} onChange={(e) => setCari(e.target.value)}></input>
                            </div>
                        </div>
                        <div className="col-md-6 mb-3">
                            <div className="input-group input-group-sm">
                                <label className="input-group-text" id="lblKisaltma" style={{width:"128px"}}>Kısaltma<span style={{color:"red", paddingLeft:"4px"}}>*</span></label>
                                <input aria-describedby="lblKisaltma" type="text" className="form-control form-control-sm" value={kisaltma} onChange={(e) => setKisaltma(e.target.value)}></input>
                            </div>
                        </div>
                        <div className="col-md-6 mb-3">
                            <div className="input-group input-group-sm">
                                <label className="input-group-text" id="lblCariTuru" style={{width:"128px"}}>Cari Türü<span style={{color:"red", paddingLeft:"4px"}}>*</span></label>
                                <select aria-describedby="lblCariTuru" className="form-select form-select-sm" value={cariTuruId} onChange={(e) => setCariTuruId(e.target.value)}>
                                    <option value="0"></option>
                                    {
                                        dataCariTuru && dataCariTuru.length > 0 ?
                                        dataCariTuru.map((item, index) => {
                                            return (
                                                <option key={index} value={item.id}>{item.ad}</option>
                                            )
                                        })
                                        :
                                        null
                                    }
                                </select>
                            </div>
                        </div>
                        <div className="col-md-6 mb-3">
                            <div className="input-group input-group-sm">
                                <label className="input-group-text" id="lblAdres" style={{width:"128px"}}>Adres</label>
                                <input aria-describedby="lblAdres" type="text" className="form-control form-control-sm" value={adres} onChange={(e) => setAdres(e.target.value)}></input>
                            </div>
                        </div>
                        <div className="col-md-6 mb-3">
                            <div className="input-group input-group-sm">
                                <label className="input-group-text" id="lblVergiDairesi" style={{width:"128px"}}>Vergi Dairesi</label>
                                <input aria-describedby="lblVergiDairesi" type="text" className="form-control form-control-sm" value={vergiDairesi} onChange={(e) => setVergiDairesi(e.target.value)}></input>
                            </div>
                        </div>
                        <div className="col-md-6 mb-3">
                            <div className="input-group input-group-sm">
                                <label className="input-group-text" id="lblVergiNo" style={{width:"128px"}}>Vergi No</label>
                                <input aria-describedby="lblVergiNo" type="text" className="form-control form-control-sm" value={vergiNo} onChange={(e) => setVergiNo(e.target.value)}></input>
                            </div>
                        </div>
                        <div className="col-md-6 mb-3">
                            <div className="input-group input-group-sm">
                                <label className="input-group-text" id="lblIlgili" style={{width:"128px"}}>İlgili</label>
                                <input aria-describedby="lblIlgili" type="text" className="form-control form-control-sm" value={ilgili} onChange={(e) => setIlgili(e.target.value)}></input>
                            </div>
                        </div>
                        <div className="col-md-6 mb-3">
                            <div className="input-group input-group-sm">
                                <label className="input-group-text" id="lblTelefon" style={{width:"128px"}}>Telefon</label>
                                <input aria-describedby="lblTelefon" type="text" className="form-control form-control-sm" value={telefon} onChange={(e) => setTelefon(e.target.value)}></input>
                            </div>
                        </div>
                        <div className="col-md-6 mb-3">
                            <div className="input-group input-group-sm">
                                <label className="input-group-text" id="lblMail" style={{width:"128px"}}>E-Posta</label>
                                <input aria-describedby="lblMail" type="text" className="form-control form-control-sm" value={mail} onChange={(e) => setMail(e.target.value)}></input>
                            </div>
                        </div>
                        <div className="col-md-6 mb-3">
                            <div className="input-group input-group-sm">
                                <label className="input-group-text" id="lblIban" style={{width:"128px"}}>IBAN</label>
                                <input aria-describedby="lblIban" type="text" className="form-control form-control-sm" value={iban} onChange={(e) => setIban(e.target.value)}></input>
                            </div>
                        </div>
                        <div className="col-md-6 mb-3">
                            <div className="input-group input-group-sm">
                                <label className="input-group-text" id="lblSwift" style={{width:"128px"}}>Swift</label>
                                <input aria-describedby="lblSwift" type="text" className="form-control form-control-sm" value={swift} onChange={(e) => setSwift(e.target.value)}></input>
                            </div>
                        </div>
                        <div className="col-md-6 mb-3">
                            <div className="input-group input-group-sm">
                                <label className="input-group-text" id="lblEori" style={{width:"128px"}}>Eori</label>
                                <input aria-describedby="lblEori" type="text" className="form-control form-control-sm" value={eori} onChange={(e) => setEori(e.target.value)}></input>
                            </div>
                        </div>
                        <div className="col-md-6 mb-3">
                            <div className="input-group input-group-sm">
                                <label className="input-group-text" id="lblTeslimatAdresi" style={{width:"128px"}}>Teslimat Adresi</label>
                                <input aria-describedby="lblTeslimatAdresi" type="text" className="form-control form-control-sm" value={teslimatAdresi} onChange={(e) => setTeslimatAdresi(e.target.value)}></input>
                            </div>
                        </div>
                        <div className="col-md-6 mb-3">
                            <div className="input-group input-group-sm">
                                <label className="input-group-text" id="lblVade" style={{width:"128px"}}>Vade (gün)</label>
                                <input aria-describedby="lblVade" type="text" className="form-control form-control-sm" value={vade} onChange={(e) => setVade(e.target.value)}></input>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-success" onClick={Kaydet}><i className="bi bi-check-lg mr-2"></i> Kaydet</button>
                    <button className="btn btn-secondary" onClick={handleClose}><i className="bi bi-x"></i> Vazgeç</button>
                </Modal.Footer>
            </Modal>
        </Fragment>
    );
};

export default Cari;